import fn from "@/utils/fn";

export const tabColumnList = [
  {
    width: 140,
    title: "日期",
    key: "date",
    align: "center",
    fixed: "left",
  },
  {
    title: "交易总额",
    key: "total_amount",
    align: "center",
    width: 150,
  },
  {
    title: "公司收入",
    key: "service_amount",
    align: "center",
    width: 150,
  },
  {
    title: "交易总订单数",
    key: "order_count",
    align: "center",
    width: 150,
  },
  {
    title: "交易成功订单数",
    key: "order_success_num",
    align: "center",
    width: 150,
  },
  {
    title: "角色交易成功订单数",
    key: "order_role_count",
    align: "center",
    width: 150,
  },
  {
    title: "货币交易成功订单数",
    key: "order_coin_num",
    align: "center",
    width: 150,
  },
  {
    title: "装备交易成功订单数",
    key: "order_equip_num",
    align: "center",
    width: 150,
  },
  {
    title: "拒绝收货退款订单数",
    key: "order_refuse_order_num",
    align: "center",
    width: 130,
  },
  {
    title: "还价成功交易订单数",
    key: "bargain_success_num",
    align: "center",
    width: 130,
  },
  {
    title: "游戏内完成交易订单数",
    key: "game_total_num",
    align: "center",
    width: 130,
  },
  {
    title: "平台完成交易订单数",
    key: "box_total_num",
    align: "center",
    width: 150,
  },
  {
    title: "上架商品总数",
    key: "on_shelf",
    align: "center",
    width: 150,
  },
  {
    title: "上架角色数",
    key: "on_shelf_role",
    align: "center",
    width: 150,
  },
  {
    title: "上架货币数",
    key: "on_shelf_coin",
    align: "center",
    width: 150,
  },
  {
    title: "上架装备数",
    key: "on_shelf_equip",
    align: "center",
    width: 120,
  },
  {
    title: "交易账号数",
    key: "order_account",
    align: "center",
    width: 130,
  },
  {
    title: "交易成功账号数",
    key: "order_success_account",
    align: "center",
    width: 130,
  },
  {
    title: "拒绝收货退款账号数",
    key: "order_refuse_account",
    align: "center",
    width: 130,
  },
];

export const tabColumnLists = [
  {
    width: 120,
    title: "ID",
    key: "game_id",
    align: "center",
    fixed: "left",
  },
  {
    title: "游戏名称",
    key: "game_name",
    align: "center",
    width: 140,
    fixed: "left",
  },
  {
    title: "交易总额",
    key: "total_success_order_amount",
    align: "center",
    width: 140,
  },
  {
    title: "交易币支付总金额",
    key: "success_trade_order_amount",
    align: "center",
    width: 140,
  },
  {
    title: "支付宝支付总金额",
    key: "success_ali_order_amount",
    align: "center",
    width: 140,
  },
  {
    title: "SVIP抵扣金额",
    key: "coupon_amount",
    align: "center",
    width: 140,
  },
  {
    title: "GM收入",
    key: "gm_amount",
    align: "center",
    width: 140,
  },
  {
    title: "拒绝收货退款总金额",
    key: "refund_order_amount",
    align: "center",
    width: 140,
  },
  {
    title: "交易总订单数",
    key: "all_order_num",
    align: "center",
    width: 140,
  },
  {
    title: "交易成功订单数",
    key: "total_success_order_num",
    align: "center",
    width: 120,
  },
  {
    title: "角色交易成功订单数",
    key: "success_role_order_num",
    align: "center",
    width: 130,
  },
  {
    title: "货币交易成功订单数",
    key: "success_coin_order_num",
    align: "center",
    width: 130,
  },
  {
    title: "装备（材料）交易成功订单数",
    key: "success_equip_order_num",
    align: "center",
    width: 140,
  },
  {
    title: "支付超时订单数",
    key: "pay_timeout_order_num",
    align: "center",
    width: 130,
  },
  {
    title: "拒绝收货退款订单数",
    key: "refund_order_num",
    align: "center",
    width: 130,
  },
  {
    title: "游戏内完成交易订单数",
    key: "game_success_order_num",
    align: "center",
    width: 150,
  },
  {
    title: "平台完成交易订单数",
    key: "box_success_order_num",
    align: "center",
    width: 150,
  },
  {
    title: "上架商品总数",
    key: "on_shelf_commodity",
    align: "center",
    width: 150,
  },
  {
    title: "上架角色数",
    key: "on_shelf_role",
    align: "center",
    width: 150,
  },
  {
    title: "上架货币数",
    key: "on_shelf_coin",
    align: "center",
    width: 120,
  },
  {
    title: "上架装备数",
    key: "on_shelf_equip",
    align: "center",
    width: 130,
  },
  {
    title: "交易成功账号数",
    key: "total_success_user_num",
    align: "center",
    width: 130,
  },
  {
    title: "拒绝收货退款订单账号数",
    key: "refund_order_user_num",
    align: "center",
    width: 130,
  },
];

export const withDrawColumnList = [
  {
    width: 140,
    title: "日期",
    key: "date",
    align: "center",
    fixed: "left",
  },
  {
    title: "提现总额",
    key: "total_extract_money",
    align: "center",
    width: 150,
  },
  {
    title: "提现至支付宝",
    key: "total_extract_ali_money",
    align: "center",
    width: 150,
  },
  {
    title: "提现至盒币",
    key: "total_extract_balance_money",
    align: "center",
    width: 150,
  },
  {
    title: "SVIP抵扣金额",
    key: "use_coupon_money",
    align: "center",
    width: 150,
  },
  {
    title: "提现手续费",
    key: "extarct_charge_money",
    align: "center",
    width: 150,
  },
  {
    title: "提现人数",
    key: "extract_user_num",
    align: "center",
    width: 150,
  },
  {
    title: "提现支付宝人数",
    key: "extract_ali_user_num",
    align: "center",
    width: 150,
  },
  {
    title: "提现盒币人数",
    key: "extract_balance_user_num",
    align: "center",
    width: 130,
  },
  {
    title: "提现订单数",
    key: "extract_num",
    align: "center",
    width: 130,
  },
  {
    title: "提现支付宝订单数",
    key: "extract_ali_num",
    align: "center",
    width: 130,
  },
  {
    title: "提现盒币订单数",
    key: "extract_balance_num",
    align: "center",
    width: 150,
  },
  {
    title: "账面交易币",
    key: "all_trade_amount",
    align: "center",
    width: 150,
  },
];

export const gameTypeList = {
  total_amount: [
    { name: "交易总额由高到低", key: "desc" },
    { name: "交易总额由低到高", key: "asc" },
  ],
  success_order_num: [
    { name: "交易成功订单数由高到低", key: "desc" },
    { name: "交易成功订单数由低到高", key: "asc" },
  ],
};
